// extracted by mini-css-extract-plugin
export default {"container":"NotificationCloseButton_container__tMC57","closeIcon":"NotificationCloseButton_closeIcon__7dlJJ"};